export default __webpack_public_path__ + "static/media/chatton10.c37959b4.jpg";